import { Controller, get } from 'react-hook-form';

import { MultiSelect } from 'primereact/multiselect';
import { classNames } from 'primereact/utils';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function MultipleSelect({
  label,
  name,
  options,
  inputField,
  renderField,
  placeholder,
  isRequired,
  disabled,
  control,
  errors,
  onSelectChange,
  panelStyle,
  readOnly,
}) {
  const { t } = useTranslation();
  return (
    <div className="field">
      <label
        className={classNames('mb-2', { hidden: !label, 'inline-block': label })}
        htmlFor={name}
      >
        {label}{' '}
        {isRequired && (
          <span className="text-red-500" style={{ fontWeight: 900 }}>
            *
          </span>
        )}
      </label>
      <Controller
        control={control}
        defaultValue={undefined}
        name={name}
        render={({ field: { onChange, value, ref } }) => (
          <div className="relative">
            <MultiSelect
              value={value}
              onChange={(e) => {
                onChange(e.value);
                onSelectChange(name, e.value);
              }}
              panelStyle={panelStyle}
              options={options}
              optionValue={inputField}
              optionLabel={renderField}
              inputRef={ref}
              placeholder={placeholder}
              dropdownIcon={disabled ? '' : 'pi pi-chevron-down'}
              showClear
              className={classNames({
                'p-invalid': !!get(errors, name),
                'surface-200': disabled,
                'opacity-100': readOnly,
              })}
              tooltip={t(get(errors, name)?.message)}
              tooltipOptions={{ position: 'bottom' }}
              disabled={disabled || readOnly}
            />
          </div>
        )}
      />
    </div>
  );
}

MultipleSelect.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.array.isRequired,
  inputField: PropTypes.string,
  renderField: PropTypes.string,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  onSelectChange: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  panelStyle: PropTypes.object,
};

MultipleSelect.defaultProps = {
  label: '',
  placeholder: '',
  inputField: 'id',
  renderField: 'name',
  isRequired: false,
  disabled: false,
  readOnly: false,
  panelStyle: {},
  onSelectChange: () => null,
};
